import { createSlice } from "@reduxjs/toolkit";

// Objetivos del catalogo, por tema de evaluacion.
const initialState = {
    defaultEntity: {
        id: 0,
        idTemaEvaluacion: 0,
        nombre: "",
        descripcion: "",
        idEstado: 2,
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
        id: 0,
        idTemaEvaluacion: 0,
        nombre: "",
        descripcion: "",
        idEstado: 2,
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listTemas: [{ id: 0, descripcion: "" }],
    listEstados: [{ id: 0, descripcion: "" }],
    validationActive: {
        idTemaEvaluacion: false,
        nombre: false,
    },
    validationMessage: [],
}

export const objetivoCatalogoSlice = createSlice({
    name: "objetivoCatalogo",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            state.entity = action.payload;
        },
        setData: (state, action) => {
            var { name, value } = action.payload;

            if (name.startsWith("id")) value = parseInt(value)

            state.entity[name] = value
            state.validationActive[name] = true
        },
        setListTemas: (state, action) => {
            state.listTemas = action.payload;
        },
        setListEstados: (state, action) => {
            state.listEstados = action.payload;
        },
        setValidationMessage: (state, action) => {
            state.validationMessage = action.payload;
        },
        activeValidations: (state, action) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
    },
});

export const { setEntity, setData, setListTemas, setListEstados
    , setValidationMessage, activeValidations } = objetivoCatalogoSlice.actions;
export default objetivoCatalogoSlice.reducer;
